// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-facets-building-blocks-Facet-module__root--2Vq5L"};